<!-- <template>
  <v-menu
    ref="menu1"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
    dense
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        dense
        outlined
        hide-details="auto"
        v-model="dateRangeText"
        label="Date range"
        persistent-hint
        v-bind="attrs"
        clearable
        v-on="on"
        @click:clear="
          (date_range = []), (filter.start = null), (filter.end = null)
        "
      ></v-text-field>
    </template>
    <v-date-picker v-model="date_range" range></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  props: {
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    date_range: [],
  }),
  methods: {
    emitInput() {
      if (this.date_range.length > 1) {
        if (
          new Date(this.date_range[1]).getTime() >
          new Date(this.date_range[0]).getTime()
        ) {
          this.$emit("start", this.date_range[0]);
          this.$emit("end", this.date_range[1]);
        } else {
          this.$emit("start", this.date_range[1]);
          this.$emit("end", this.date_range[0]);
        }
      } else {
        this.$emit("start", this.date_range[0]);
      }
    },
  },
  computed: {
    dateRangeText() {
      return this.date_range.join(" ~ ");
    },
  },
  watch: {
    clear: {
      handler(val) {
        this.date_range = [];
      },
      deep: true,
    },
    dateRangeText: {
      handler(val) {
        this.emitInput();
      },
      deep: true,
    },
  },
};
</script> -->

<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="dateRangeText"
        label="Date range"
        readonly
        outlined
        dense
        clearable
        v-bind="attrs"
        v-on="on"
        @click:clear="clearDates"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="dates"
      range
      no-title
      scrollable
      @change="onDateChange"
    >
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
      <v-btn text color="primary" @click="applyDates">OK</v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => ({ start: null, end: null })
    },
    clear: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      menu: false,
      dates: [], // ['2025-11-01', '2025-11-30']
    };
  },

  computed: {
    dateRangeText() {
      if (!this.dates || this.dates.length === 0) return '';
      if (this.dates.length === 1) return this.dates[0];
      const [start, end] = this.dates[0] < this.dates[1]
        ? [this.dates[0], this.dates[1]]
        : [this.dates[1], this.dates[0]];
      return `${start} ~ ${end}`;
    }
  },

  watch: {
    clear(val) {
      if (val) {
        this.clearDates();
        // Reset the parent's clear trigger
        this.$nextTick(() => {
          this.$emit('update:clear', false);
        });
      }
    }
  },

  methods: {
    clearDates() {
      this.dates = [];
      this.emitRange(null, null);
    },

    applyDates() {
      this.menu = false;
      if (this.dates.length === 0) {
        this.emitRange(null, null);
      } else {
        let [start, end] = this.dates;
        if (this.dates.length === 2) {
          if (new Date(end) < new Date(start)) [start, end] = [end, start];
          this.emitRange(start, end);
        }
      }
    },

    onDateChange() {
      // Optional: auto-apply on second selection
      if (this.dates.length === 2) {
        this.applyDates();
      }
    },

    emitRange(start, end) {
      this.$emit('update', { start, end });
      this.$emit('change', { start, end });
    }
  }
};
</script>